import React, { useState, useEffect } from "react";
import Recentorder from "./Recentorder";
import "react-perfect-scrollbar/dist/css/styles.css";
import { Tab, Nav } from "react-bootstrap";
import Chart from "./Chart";
import Trendingorder from "./Trendingorder";
import { ReportService } from "../../../services/reports-service";
import { Formik } from "formik";
import * as Yup from "yup";
import moment from "moment";

export const Homecontent = () => {
  const [dashboardinfo, setDashboardInfo] = useState({
    items_sold: "",
    total_discounts: "",
    total_orders: "",
    total_sales: "",
  });

  const onSubmitForm = async (
    values,

    { resetForm, setErrors, setStatus, setSubmitting, setFieldValue }
  ) => {
    //todo extra validations

    try {
      const result = await ReportService.reportdashboardDetails(
        values.from,
        values.to
      );

      const info = {};
      const dashboarddata = result;

      info.items_sold = dashboarddata.items_sold;
      info.total_discounts = dashboarddata.total_discounts;
      info.total_orders = dashboarddata.total_orders;
      info.total_sales = dashboarddata.total_sales;

      setDashboardInfo(info);
    } catch (err) {}
  };

  const format2 = "YYYY-MM-DD";

  const today = new Date();
  const yesterday = new Date(today);
  const lastsevenday = new Date(today);
  const lastthirtyday = new Date(today);

  yesterday.setDate(yesterday.getDate() - 1);
  lastsevenday.setDate(lastsevenday.getDate() - 7);
  lastthirtyday.setDate(lastthirtyday.getDate() - 30);

  let todayda = moment(today).format(format2);
  let yesterda = moment(yesterday).format(format2);
  let sevenda = moment(lastsevenday).format(format2);
  let thirtyda = moment(lastthirtyday).format(format2);

  const SearchTodayday = async () => {
    try {
      const result = await ReportService.reportdashboardDetails(
        todayda,
        todayda
      );

      const info = {};
      const dashboarddata = result;

      info.items_sold = dashboarddata.items_sold;
      info.total_discounts = dashboarddata.total_discounts;
      info.total_orders = dashboarddata.total_orders;
      info.total_sales = dashboarddata.total_sales;

      setDashboardInfo(info);
    } catch (err) {
      //toast
      console.error(err);
    }
  };

  const SearchYesterday = async () => {
    try {
      const result = await ReportService.reportdashboardDetails(
        yesterda,
        todayda
      );

      const info = {};
      const dashboarddata = result;

      info.items_sold = dashboarddata.items_sold;
      info.total_discounts = dashboarddata.total_discounts;
      info.total_orders = dashboarddata.total_orders;
      info.total_sales = dashboarddata.total_sales;

      setDashboardInfo(info);
    } catch (err) {
      //toast
      console.error(err);
    }
  };

  const SearchSevenday = async () => {
    try {
      const result = await ReportService.reportdashboardDetails(
        sevenda,
        todayda
      );

      const info = {};
      const dashboarddata = result;

      info.items_sold = dashboarddata.items_sold;
      info.total_discounts = dashboarddata.total_discounts;
      info.total_orders = dashboarddata.total_orders;
      info.total_sales = dashboarddata.total_sales;

      setDashboardInfo(info);
    } catch (err) {
      //toast
      console.error(err);
    }
  };

  const SearchThirtyday = async () => {
    try {
      const result = await ReportService.reportdashboardDetails(
        thirtyda,
        todayda
      );
      const info = {};
      const dashboarddata = result;

      info.items_sold = dashboarddata.items_sold;
      info.total_discounts = dashboarddata.total_discounts;
      info.total_orders = dashboarddata.total_orders;
      info.total_sales = dashboarddata.total_sales;

      setDashboardInfo(info);
    } catch (err) {
      //toast
      console.error(err);
    }
  };

  return (
    <div className="ms-content-wrapper">
      <div className="row">
        <div className="col-md-12">
          <h1 className="db-header-title">Welcome</h1>
        </div>

        <div className="col-md-12">
          <Formik
            initialValues={{
              from: "",
              to: "",
            }}
            validationSchema={Yup.object().shape({})}
            onSubmit={onSubmitForm}
          >
            {({ handleBlur, handleChange, values, submitForm, isValid }) => (
              <div className="row">
                <div className="col-md-4">
                  <div className="mb-3">
                    <label htmlFor="validationCustom08">From</label>
                    <div className="input-group">
                      <input
                        name="from"
                        type="date"
                        className="form-control"
                        id="fromID"
                        required
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.from}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="mb-3">
                    <label htmlFor="validationCustom08">To</label>
                    <div className="input-group">
                      <input
                        name="to"
                        type="date"
                        className="form-control"
                        id="toID"
                        required
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.to}
                      />
                    </div>
                  </div>
                </div>
                <div
                  className="col-md-4 mt-4"
                  style={{ display: "flex", justifyContent: "flex-start" }}
                >
                  <button
                    type="button"
                    className="ms-btn-icon btn-primary"
                    name="button"
                    onClick={submitForm}
                  >
                    <i className="material-icons">arrow_forward</i>
                  </button>
                </div>
              </div>
            )}
          </Formik>
        </div>

        <div className="col-md-12">
          <div className="ms-panel ms-widget ms-crypto-widget">
            <div className="ms-panel-body p-0">
              <Tab.Container defaultActiveKey="mon">
                <Nav
                  variant="tabs"
                  className="nav nav-tabs nav-justified has-gap px-4 pt-4"
                >
                  <Nav.Item>
                    <Nav.Link eventKey="mon" onClick={SearchTodayday}>
                      Today
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="tue" onClick={SearchYesterday}>
                      Yesterday
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="wed" onClick={SearchSevenday}>
                      {" "}
                      Last 7 days
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="thu" onClick={SearchThirtyday}>
                      {" "}
                      Last 30 days
                    </Nav.Link>
                  </Nav.Item>
                </Nav>

                <Tab.Content>
                  <Tab.Pane eventKey="mon">
                    <div className="col-md-12 mt-5">
                      <Chart
                        total_sales={dashboardinfo.total_sales}
                        total_discounts={dashboardinfo.total_discounts}
                        total_orders={dashboardinfo.total_orders}
                        items_sold={dashboardinfo.items_sold}
                      />
                    </div>
                  </Tab.Pane>
                  <Tab.Pane eventKey="tue">
                    <div className="col-md-12 mt-5">
                      <Chart
                        total_sales={dashboardinfo.total_sales}
                        total_discounts={dashboardinfo.total_discounts}
                        total_orders={dashboardinfo.total_orders}
                        items_sold={dashboardinfo.items_sold}
                      />
                    </div>
                  </Tab.Pane>
                  <Tab.Pane eventKey="wed">
                    <div className="col-md-12 mt-5">
                      <Chart
                        total_sales={dashboardinfo.total_sales}
                        total_discounts={dashboardinfo.total_discounts}
                        total_orders={dashboardinfo.total_orders}
                        items_sold={dashboardinfo.items_sold}
                      />
                    </div>
                  </Tab.Pane>
                  <Tab.Pane eventKey="thu">
                    <div className="col-md-12 mt-5">
                      <Chart
                        total_sales={dashboardinfo.total_sales}
                        total_discounts={dashboardinfo.total_discounts}
                        total_orders={dashboardinfo.total_orders}
                        items_sold={dashboardinfo.items_sold}
                      />
                    </div>
                  </Tab.Pane>
                  <Tab.Pane eventKey="fri">
                    <div className="col-md-12 mt-5">
                      <Chart />
                    </div>
                  </Tab.Pane>
                </Tab.Content>
              </Tab.Container>
            </div>
          </div>
          {/* Favourite Products */}
        </div>
        <div className="col-md-12">
          <Trendingorder />
        </div>
        {/* END/Food Orders */}
        {/* Recent Placed Orders< */}
        <div className="col-12">
          <div className="ms-panel">
            {/* <div className="ms-panel-header">
              <h6>Recently Placed Orders</h6>
            </div> */}
            <div className="ms-panel-body">
              <Recentorder />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Homecontent;
